import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Radio, RadioGroup, Text } from 'rsuite';

import { ControlPumpSpeedOptions } from '../constants';
import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplayControlPumpSpeed = ({ register, tc, icon, onChange, disabled, borderOff }) => {
  const [value, setValue] = useState(() =>
    Number.isFinite(register.value) ? register.value : ControlPumpSpeedOptions[0].value,
  );

  const updateValue = (value, event) => {
    devLog(event, value);
    setValue(value);
    onChange(register, value);
  };

  useEffect(() => {
    setValue(Number.isFinite(register.value) ? register.value : ControlPumpSpeedOptions[0].value);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div
          className="truncate space-y-0.5 w-1/4"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Text color={tc} className="">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          className="truncate w-1/2 space-y-1"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Flex justifyContent="end" className="space-x-4 ">
            <RadioGroup
              name={`radioList-${register.address}`}
              inline
              appearance="picker"
              onChange={updateValue}
              value={value}
            >
              {ControlPumpSpeedOptions.map((item) => (
                <Radio key={item.value + 1} value={item.value} disabled={disabled}>
                  {' '}
                  {item.label}{' '}
                </Radio>
              ))}
            </RadioGroup>
          </Flex>
        </div>
      </Flex>
    </Panel>
    // </div>
  );
};
